import { modalSlice } from './slice'
export const modalActions = modalSlice.actions

export const showModal = (message, title, reasonCode, redirectUrl) => (dispatch) => {
    return dispatch(modalActions.showError({ message, title, reasonCode, redirectUrl }))
}
export const removeModal = () => (dispatch) => {
    dispatch(modalActions.clearModal())
}
